import React from 'react';
import { View } from 'react-native';

import { common } from '@/styles/styles';

import { Text } from './TextComponent';
import { ds } from './lib/design.system';

type ErrorMessagePaymentProps = {
    errorMessage: string;
};

export const ErrorMessagePayment = ({ errorMessage }: ErrorMessagePaymentProps) => (
    <View style={[common.alignCenter, common.justifyCenter]}>
        <Text variant="bodySmall" color={ds.colorToken.text.danger} textAlign={'center'} testID="paymentErrorMsg">
            {errorMessage || ' '}
        </Text>
    </View>
);
